import React from "react";
import PropTypes from "prop-types";

/**
 * Compact, reusable title+count subheader.
 * - Uses Bootstrap utility classes for layout
 * - Adds light inline spacing to ensure consistent look even if utilities change
 * - Works with BS4 ("badge badge-secondary badge-pill") by default
 */
const SectionSubheader = ({
  title,
  count,
  className,
  style,
  badgeClassName,
}) => {
  return (
    <div
      className={`d-flex align-items-center mt-2 mb-2 ${className || ""}`}
      style={{ gap: 8, ...style }}
      data-testid={`section-subheader-${title}`}
    >
      <p className="m-0 font-weight-bold">{title}</p>
      <span
        className={badgeClassName || "badge badge-secondary badge-pill"}
        aria-label={`${title} count`}
      >
        {count}
      </span>
    </div>
  );
};

SectionSubheader.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  badgeClassName: PropTypes.string,
};

export default SectionSubheader;
